import {Grid, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {SelectInputElement} from './SelectInputElement';
import {SwitchSegmentedYesNo} from '../../../Core/UI';
import React from 'react';
import {Prequal} from '../../../Core/mobx/ParameterStore/Prequal';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {observer} from 'mobx-react-lite';
import Basic from '../../Questions/Basic';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/PrequalXref';

const useStyles = makeStyles({
    icon: {
        marginRight: 4,
    },
    approved: {
        color: 'green',
    },
    denied: {
        color: 'red',
    },
    sectionTitle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 46,
        width: 46,
        borderRadius: '50%',
        backgroundColor: '#e8edec',
        color: '#456d69',
        marginRight: 21,
        fontSize: 26,
        textAlign: 'center',
    },
    sectionTitleWrapper: {
        display: 'flex',
        alignItems: 'center',
        textTransform: 'capitalize',
    },
    numberOfChildrenBox: {
        margin: '56px 8px 0',
        boxShadow: '0px 0px 5px 0px #00000033',
    },
    numberOfChildrenLabel: {
        marginBottom: 16,
        fontFamily: 'Fredoka',
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '100%',
    },
});

type BasicInfoProps = {
    valueChanged: (p?: Parameter, value?: any) => void;
    parameters: Prequal;
    hideNumbers?: boolean;
};

const BasicInfo = observer(({valueChanged, parameters, hideNumbers}: BasicInfoProps) => {
    const classes = useStyles();
    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );

    return (
        <Grid container style={{marginBottom: 24}} spacing={2}>
            <Grid item xs={12} style={{marginBottom: 24}}>
                <div className={classes.sectionTitleWrapper}>
                    {!hideNumbers && <span className={classes.sectionTitle}>1</span>}
                    <Typography
                        style={{
                            fontSize: 24,
                            fontWeight: 700,
                            fontFamily: 'LoraSemiBold',
                            lineHeight: '120%',
                            letterSpacing: 0,
                        }}
                    >
                        Basics
                    </Typography>
                </div>
            </Grid>

            <Basic valueChanged={valueChanged} parameters={parameters} threeColumnLayout prequal />

            <Grid item xs={4} style={{marginTop: 0}}>
                <SwitchSegmentedYesNo
                    param={{
                        label: 'Children',
                        name: 'kids',
                        ...parameters.kids,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            {parameters.kids.value && (
                <Grid
                    item
                    xs={12}
                    className={classes.numberOfChildrenBox}
                    style={{
                        padding: '17px 25px 24px',
                    }}
                >
                    <Grid item xs={4}>
                        <Typography className={classes.numberOfChildrenLabel}>Children</Typography>
                        <SelectInputElement
                            param={{
                                label: '# of Children',
                                name: 'kidsNumber',
                                options: fieldOptions.kidsNumber.options,
                                ...parameters.kidsNumber,
                            }}
                            required={''}
                            valueChanged={valueChanged}
                            inputProps={{placeholder: '# of Children'}}
                            newLabelType
                            showExtraLabel
                        />
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
});

export default BasicInfo;
